<div class="sa-header">
  <div class="sa-header__brand" (click)="goToMainApp()" style="cursor: pointer">
    <img alt="Freely Logo" src="/assets/logos/freely-logo-white.svg" class="sa-header__logo">
    <div class="sa-header__title">
      <span class="sa-header__title-accept">Accept</span>
      <span class="sa-header__title-admin">System Administration</span>
    </div>
  </div>

  <nav class="sa-header__nav">
    @for (link of navLinks(); track link.path) {
      <a [routerLink]="link.path"
         class="sa-header__nav-link"
         [class.active]="isActive(link.path)"
         [attr.aria-current]="isActive(link.path) ? 'page' : null">
        {{ link.label }}
      </a>
    }
  </nav>

  <div class="sa-header__actions">
    <button mat-button class="sa-header__back-btn" (click)="goToMainApp()">
      <mat-icon fontSet="fa" fontIcon="fa-arrow-left"></mat-icon>
      Back to App
    </button>

    <button
      class="sa-header__user-btn"
      (click)="isMenuOpen = !isMenuOpen"
      type="button"
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
    >
      <app-avatar size="medium" [profileId]="activeProfile()?.profileDetail?.profileId" />
    </button>

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayPositions]="[{
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top'
      }]"
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isMenuOpen"
    >
      <div class="sa-header__menu">
        <button class="sa-header__menu-close" (click)="isMenuOpen = false">
          <mat-icon fontSet="fa" fontIcon="fa-xmark" />
        </button>
        <div class="sa-header__menu-info">
          <app-avatar size="large" [profileId]="activeProfile()?.profileDetail?.profileId" />
          <div>
            <h5>{{ userName() }}</h5>
            <p>System Administrator</p>
          </div>
        </div>
        <div class="sa-header__menu-actions">
          <button mat-raised-button mat-stroked-button (click)="goToMainApp(); isMenuOpen = false">
            Back to App
          </button>
          <button mat-raised-button mat-stroked-button type="button" (click)="logout()">
            Sign Out
          </button>
        </div>
      </div>
    </ng-template>
  </div>
</div>
